module.exports = __webpack_public_path__ + "img/icon-dexid.bb9ba16d.svg";